import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class LoginService {


    constructor(private http: Http) { }

    login(username: string, password: string) {

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return this.http.post('/master/login', JSON.stringify({ username: username, password: password }),
            { headers: headers })
            .map((response: Response) => {
                if (response.json().code == 200) {
                    let user = response.json().user[0];
                    // localStorage.setItem('currentUser', JSON.stringify(user.id));
                    // console.log(user.id);
                    return user;
                } else if (response.json().code == 201) {  //密码输入不正确
                    return '201';
                } else {          //用户名不正确
                    return '202'
                }
            });

    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
    }

}


// WEBPACK FOOTER //
// ./src/app/services/login.service.ts